define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"csi/xml",
	"csi/xml/Query"
], function(array,declare,AggregateFrom,xml,Query) {

	return declare(AggregateFrom, {
		applyActionFilters: function(/*csi.view.Widget*/view) {
			var q = new Query();

			array.forEach(this.getParent().ShapeSeasons, function(s) {
				this.RefAttr("ParentSeason", xml.OP_EQUALS, s);
			}, q.Or());

			view.relRoot.addQuery(q);

			this.inherited(arguments);
		}
	});
});